module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5721-bijuterias.fc27ebdf.jpg";